<template>
  <div class="bg-white p-4" style="min-height: calc(100vh - 118px)">
    <div class="goback mb-3">
      <img class="goback-img" src="@/assets/img/go_back.png" alt="" /><span @click="$router.back()">回到费用结算页</span>
    </div>
    <div class="wrap">
      <div class="bc" style="position: relative">
        <!-- 查询 -->
        <el-row :gutter="24" class="search-row" type="flex" justify="space-between">
          <el-col :span="16">
            <search-filter :search-filters="queryFields" :change-handel-function="onChangeSearchField" />
          </el-col>
          <el-col :span="8" style="text-align: right">
            <el-button class="tips-btn" size="small" icon="el-icon-download" @click="DownloadExportPDF"
              >导出PDF
              <div class="tips">
                <el-tooltip class="item" effect="light" content="导出财务报销凭证（带水印的PDF格式的文件）" placement="top-start">
                  <!-- <img src="@/assets/img/tips_red.png" width="14" /> -->
                  <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-small"></i>
                </el-tooltip>
              </div>
            </el-button>
            <el-button class="tips-btn" size="small" type="primary" icon="el-icon-download" @click="DownloadExportDetailExcel"
              >导出Excel
              <div class="tips">
                <el-tooltip class="item" effect="light" content="导出费用明细（Excel文件，可用于统计分析）" placement="top-start">
                  <!-- <img src="@/assets/img/tips_red.png" width="14" /> -->
                  <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-small"></i>
                </el-tooltip>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <data-table
          cell-class-name="truncate-table-cell-wrap"
          :data="data"
          :columns="option.column"
          :page="page"
          :showPage="true"
          :index="true"
          :indexFixed="true"
          :loading="loading"
          :selection="true"
          @size-change="sizeChange"
          @pagination-current-change="currentChange"
          @selection-change="SelectionChange"
          ref="tableRef"
          :height="'calc(100vh - 269px)'"
        >
          <!-- 结算状态 -->
          <template #settleStatus="{ row }">
            <div :class="[settleStatusColorMap[row.settleStatus], 's-status']">
              {{ settleStatusMap[row.settleStatus] }}
            </div>
          </template>
          <!-- 调价说明 -->
          <template #adjustDescribe="{ row }">
            <div style="text-align: left" v-if="row.adjustAmount">
              <p>调价人：{{ row.adjusterName }}，调整时间：{{ row.adjustTime }}，</p>
              <p>调整说明：{{ row.adjustDescribe }}</p>
            </div>
          </template>
          <!-- 支付方式 -->
          <template #payType="{ row }">
            <span>{{ payTypeMapCrud[row.payType] }}</span>
          </template>
          <!-- 空状态 -->
          <template slot="empty">
            <empty-prompt :isAllOrNet="true" />
          </template>
          <!-- 菜单 -->
          <template #opt="{ row }">
            <el-button type="text" class="" @click="openDrawer(row)">查看结算单</el-button>
            <el-button type="text" v-if="row.settleStatus == 1 || row.settleStatus == 3" @click="showDialog(row)"
              >调整结算价</el-button
            >
            <el-button
              type="text"
              v-if="row.settleStatus == 1 || row.settleStatus == 3"
              @click="showSettlementBillDialog(row, 'start', 'single')"
              >发起结算单确认</el-button
            >
            <el-button
              type="text"
              v-if="row.settleStatus != 5 && row.settleStatus != 6 && row.settleStatus != 7"
              @click="showSettlementBillDialog(row, 'cancel', 'single')"
              disabled
              >撤销</el-button
            >
            <!-- <el-popover
              v-if="row.settleStatus==4"
              placement="bottom-start"
              width="50"
              popper-class="pay-popover"
              :visible-arrow="false"
              trigger="hover">
              <div style="text-align: center; margin: 0">
                <el-button size="small" @click="showSettlementBillDialog(row,'payOnline','single')">线上支付</el-button>
                <el-button size="small" @click="showSettlementBillDialog(row,'pay','single')">线下支付</el-button>
                <el-button size="small" @click="showSettlementBillDialog(row,'payApprove','single')">审批支付</el-button>
              </div>
              <a slot="reference">支付</a>
            </el-popover> -->
            <el-button
              type="text"
              v-if="row.settleStatus == 4 || row.settleStatus == 9 || row.settleStatus == 10"
              @click="showSettlementBillDialog(row, 'payApprove', 'single')"
              >发起财务付款审批
            </el-button>
            <el-button type="text" v-if="row.settleStatus == 7 || row.settleStatus == 8" @click="toSettlementPayDetail(row)"
              >查看财务付款审批
            </el-button>
          </template>
        </data-table>
        <div class="sum-line">
          <span
            >已勾选结算单费用总和（元）：<span>{{ sheetAmountSum }}</span></span
          >
          <el-button @click="showSettlementBillDialog({}, 'start', 'bach')" type="primary" disabled>发起结算单确认</el-button>
          <el-button @click="showSettlementBillDialog({}, 'cancel', 'bach')" disabled>撤销结算单</el-button>
          <el-button @click="showSettlementBillDialog({}, 'payApprove', 'bach')" type="primary" disabled
            >发起财务付款审批</el-button
          >
          <!-- <el-popover
            placement="bottom-start"
            width="50"
            popper-class="pay-popover-bach"
            :visible-arrow="false"
            trigger="hover">
            <div style="text-align: right; margin: 0">
              <el-button size="small" @click="showSettlementBillDialog(row,'payOnline','bach')">线上支付</el-button>
              <el-button size="small" @click="showSettlementBillDialog({},'pay','bach')">线下支付</el-button>
            </div>
            <el-button slot="reference" size="small" type="primary">批量支付</el-button>
          </el-popover> -->
          <!-- <span class="total-sum">结算单费用合计（元）：<span>{{totalYuanAmount}}</span></span> -->
        </div>
        <el-dialog
          :title="dialogSettlementBillTitle"
          :visible.sync="dialogSettlementBillVisible"
          width="600px"
          :before-close="handleSettlementBillClose"
        >
          <el-row v-if="dialogType == 'bach'">
            <el-col :span="24" class="bach-line">
              <p v-if="dialogTypeSub == 'cancel'" style="text-indent: 2em">
                您已选中<span class="bach-blue">{{ sheetNum }}</span>
                张非“已结算”状态的结算单，【确定】后将为您撤销，撤销后
                <span class="bach-red">不可恢复</span>，且将释放结算单中答卷回未结算答卷列表，您可
                <span class="bach-red">重新生成结算单</span>。
              </p>
              <p v-if="dialogTypeSub == 'start'" style="text-indent: 2em">
                您已选中<span class="bach-blue">{{ sheetNum }}</span> 张“未发起”状态的结算单，{{
                  settleType == 0
                    ? '发起结算确认后，由代理商进行确认，代理确认后，结算单方才正式生效。'
                    : '【确定】后将通过面访APP发送给调查员，请其确认。'
                }}在将结算单状态置为”已结算“前，您可对其进行撤销操作，并重新生成结算单。
              </p>
              <p v-if="dialogTypeSub == 'pay'" style="text-indent: 2em">
                请在<span class="bach-red">完成线下打款后</span>，再进行此项确认。 <br />
                您已选中<span class="bach-blue">{{ sheetNum }}</span
                >条已确认结算单，将一起对其确认。<br />
                此操作不可逆，确认已支付吗？
              </p>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="24" class="bach-line">
              <p v-if="dialogTypeSub == 'cancel'" style="text-indent: 2em">
                您确定撤销“{{ settleType == 0 ? '代理' : '调查员' }}：{{ visitorName }}，单号：{{
                  billCode
                }}”的结算单吗？【确定】即撤销，撤销后
                <span class="bach-red">不可恢复</span>，且将释放结算单中答卷回未结算答卷列表，您可
                <span class="bach-red">重新生成结算单</span>。
              </p>
              <p v-if="dialogTypeSub == 'start'" style="text-indent: 2em">
                您确定对“{{ settleType == 0 ? '代理' : '调查员' }}：{{ visitorName }}，单号：{{
                  billCode
                }}”的结算单发起结算确认吗？
                {{
                  settleType == 0
                    ? '发起结算确认后，由代理商进行确认，代理确认后，结算单方才正式生效。'
                    : '【确定】后将通过面访APP发送给调查员，请其确认。'
                }}在将结算单状态置为“已结算”前，您可对 其进行撤销操作，并重新生成结算单。
              </p>
              <p v-if="dialogTypeSub == 'pay'" style="text-indent: 2em">
                请在<span class="bach-red">完成线下打款后</span>，再进行此项确认。 <br />
                交易对像：{{ visitorName }} <br />
                此操作不可逆，确认已支付吗？
              </p>
            </el-col>
          </el-row>
          <div v-if="dialogTypeSub == 'start'">
            <label class="ml-8">结算方式：</label>
            <el-radio-group v-model="paymentMethod">
              <el-radio :label="1">线下结算</el-radio>
              <el-radio :label="2">线上结算</el-radio>
            </el-radio-group>
            <el-tooltip class="item" placement="top">
              <div slot="content">
                通过调研工厂发放执行费用，为您节约成本，需与调研工厂签署服务协议<a
                  class="text-blue cursor-pointer"
                  @click="getMore"
                  >了解更多</a
                >
              </div>
              <i class="el-icon-question cursor-pointer"></i>
            </el-tooltip>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleSettlementBillClose">取 消</el-button>
            <el-button type="primary" @click="saveComfirm()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
          <el-form
            :model="dialogForm"
            :rules="rules"
            ref="dialogForm"
            label-width="180px"
            class="demo-dialogForm"
            label-position="left"
          >
            <el-row>
              <el-col :span="24" class="bach-line">
                <span>调查员：</span>
                <span>{{ visitorName }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="bach-line">
                <span>答卷数量：</span>
                <span>{{ sheetNum }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="bach-line">
                <span>结算费用合计（元）：</span>
                <span>{{ dialogUnitPrice }}</span>
              </el-col>
            </el-row>
            <el-form-item label="实际结算费用（元）：" prop="realAmount">
              <el-input v-model="dialogForm.realAmount" placeholder="请输入正数，最多支持两位小数"></el-input>
            </el-form-item>
            <el-form-item label="调价原因：" prop="adjustDescribe">
              <el-input v-model="dialogForm.adjustDescribe" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="editMoney()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title="财务付款审批"
          :visible.sync="payApprovalDetailVisible"
          width="75%"
          destroy-on-close
          :before-close="handlepayApprovalDetailClose"
        >
          <settlement-approval
            :includeStatementIds="includeStatementIds"
            :type="1"
            :showCancelAudit="showCancelAudit"
            ref="s-approval"
          >
          </settlement-approval>
        </el-dialog>
        <el-drawer
          :title="settleType != 2 && settleType != 3 ? '委托代理费结算单' : '调查员劳务费结算单'"
          size="80%"
          :visible.sync="drawer"
          :with-header="true"
        >
          <settlement-detail ref="detailDrawer" :id="settlementId" :settleType="settleType"> </settlement-detail>
        </el-drawer>
        <OnlinePayService ref="onlinePayServiceVisible" />
      </div>
    </div>
    <online-pay title="线上支付" :visible.sync="onlinePayVisible" :survey-id="$route.query.id" :pay-info="onlinePayInfo" />
    <approval-pay
      :visible.sync="approvalPayVisible"
      :paymentInfo="paymentInfo"
      :payApprovePayType="payApprovePayType"
      @refresh="commonChange"
    />
  </div>
</template>
<script>
import { getAnswerHList, getOfflineAnswerHList } from '@/api/wenjuan/cost'
import mixins from './settlement-bill-list-mixins'
import { assignment } from '@/assets/js/utils'
import SettlementDetail from '@/views/survey/settlement/components/settlement-detail'
import ApprovalPay from '@/views/survey/settlement/components/approval-pay'
import SearchFilter from '@/components/search-filter/SearchFilter'
import OnlinePay from '@/components/pay'
import SettlementApproval from '@/components/approval/SettlementApproval'
import OnlinePayService from '@/components/online-pay-service'
import { payTypeMapCrud } from '@/assets/js/config/payTypeMap'
import DataTable from '@/components/base/DataTable'
import EmptyPrompt from '@/components/base/EmptyPrompt'

export default {
  mixins: [mixins],
  components: {
    DataTable,
    SettlementDetail,
    SearchFilter,
    OnlinePay,
    ApprovalPay,
    SettlementApproval,
    OnlinePayService,
    EmptyPrompt
  },
  data() {
    return {
      settlementId: '',
      drawer: false,
      loading: false,
      payVisible: false,
      settleStatusMap: {
        1: '未发起',
        2: '待确认',
        3: '不认可',
        4: '已确认',
        5: '已撤销',
        6: '已结算',
        7: '已打款',
        8: '审批中',
        9: '审批已撤销',
        10: '审批拒绝'
      },
      settleStatusColorMap: {
        1: 'no-start',
        2: 'confirming',
        3: 'refused',
        4: 'confirmed',
        5: 'cancelled',
        6: 'settled',
        7: 'paid',
        8: 'approvaling',
        9: 'approvaling',
        10: 'approvaling'
      },
      paymentMethod: 1,
      payTypeMapCrud
    }
  },
  computed: {},
  methods: {
    getMore() {
      this.$refs.onlinePayServiceVisible.openDialog()
    }
  }
}
</script>
<style scoped lang="scss">
.wrap {
  width: 100%;

  ul {
    display: flex;
    margin-bottom: 20px;

    li {
      width: 101px;
      height: 36px;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid rgba(220, 223, 230, 1);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(48, 49, 51, 1);
    }
  }
}
.tips {
  position: absolute;
  top: 2px;
  right: 0px;
  cursor: pointer;
}
.tips-btn {
  position: relative;
}
::v-deep.el-table th div {
  line-height: 23px;
  white-space: normal;
  padding-left: 0px;
  display: block;
}
.tips-p {
  position: absolute;
  top: -40px;
  right: 115px;
  cursor: pointer;
  margin: 0;
}
.tips-p2 {
  position: absolute;
  top: -40px;
  right: 118px;
  cursor: pointer;
  margin: 0;
}
.bach-red {
  color: red;
  font-size: 14px;
  font-weight: 600;
}
.bach-blue {
  color: blue;
  font-size: 14px;
  font-weight: 600;
}
.bach-line {
  margin-bottom: 25px;
  padding-left: 10px;
}
.sum-line {
  //position: absolute;
  //bottom: 2px;
  //left: 6px;
  .el-button {
    margin-left: 10px;
  }
  .total-sum {
    position: relative;
    left: 30px;
  }
}
::v-deep.avue-crud__pagination {
  margin-top: 0px;
}
::v-deep.el-pagination__jump {
  margin-left: 10px;
  font-weight: normal;
  color: #606266;
}
::v-deep.avue-crud__tip {
  display: none;
}
::v-deep.el-table__body {
  a {
    margin-right: 10px;
    color: #227ffe;
  }
}
.goback {
  cursor: pointer;
  opacity: 0.45;
  font-size: 15px;
  font-family: MicrosoftYaHei;
  color: #000000;
  line-height: 22px;
  img {
    width: 17px;
    height: 12px;
    margin-right: 8px;
  }
}
.no-start {
  color: #cccccc;
  background: #ffffff;
  border: 1px solid #cccccc;
}
.confirming {
  color: #ff463a;
  background: #fff6ec;
  border: 1px solid #ff463a;
}
.refused {
  color: #ff9932;
  background: #fff6ec;
  border: 1px solid #ff9932;
}
.confirmed {
  color: #4996fe;
  background: #eff6ff;
  border: 1px solid #4996fe;
}
.cancelled {
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.45);
}
.settled {
  color: #b2d799;
  background: #f0f9ea;
  border: 1px solid #b2d799;
}
.paid {
  color: #fff;
  background: #53a41d;
}
.approvaling {
  color: #333;
  background: #ffffff;
  border: 1px solid #333;
}
::v-deep.el-drawer__body {
  overflow-y: scroll;
  background-color: #f5f5f5;
  .el-card.is-always-shadow {
    box-shadow: unset;
  }
  .el-card__body {
    background-color: #f5f5f5;
    padding: 8px;
  }
}
::v-deep.el-drawer__header {
  margin-bottom: 0px;
  padding: 10px 0 10px 20px;
  background-color: #fff;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  opacity: 0.85;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #111111;
  line-height: 16px;
}
.s-status {
  border-radius: 2px;
  width: 78px;
  display: inline-block;
  height: 26px;
}
::v-deep.el-table__row {
  background-color: #ffffff !important;
}
::v-deep.el-table__row--striped td {
  background-color: #f5f5f5 !important;
}
.avue-crud ::v-deep.el-table th {
  background-color: #f5f5f5;
}
</style>
